import {
  Component,
  InputSignal,
  input,
  Output,
  EventEmitter,
  input as inputSignal,
} from '@angular/core';
import { TranslateDirective, TranslateService } from '@ngx-translate/core';
import { ActivatedRoute, Router } from '@angular/router';
import { GeoAvailabilityMetric } from '../../core/models';

export type GeographyStatsItem = {
  name: GeoAvailabilityMetric;
  label: string;
  ids: number[];
  count: number;
};

@Component({
  selector: 'app-geography-stats',
  template: `
    <h2>{{ 'main.mobile.geo_stats_header' | translate }}</h2>
    <div class="container">
      <div class="row">
        <div class="cell highlighted"></div>
        <div class="cell text-align-center">
          # {{ 'main.labels.Available' | translate | uppercase }}
        </div>
      </div>
      @for (item of data(); track item) {
        <div class="row">
          <div class="cell highlighted">{{ item.label.toUpperCase() }}</div>
          <div class="cell text-align-center">
            <a (click)="handleClick(item.name)" [attr.data-type]="item.name">
              {{
                getTemplateTranslation('main.labels.Asset_count', item.count)
              }}
            </a>
          </div>
        </div>
      }
    </div>
  `,
  styleUrls: ['./geography-stats.component.scss'],
  standalone: false,
})
export class GeographyStatsComponent {
  public data: InputSignal<GeographyStatsItem[] | null> = inputSignal<
    GeographyStatsItem[] | null
  >(null);

  @Output()
  public navigate = new EventEmitter<string>();

  constructor(
    public translateService: TranslateService,
    public route: ActivatedRoute,
    public router: Router
  ) {}

  public handleClick(name: string): void {
    this.navigate.emit(name);
  }

  // This field is using an old translation that doesn't utilize translate library's built in replacement functionality.
  public getTemplateTranslation = (
    translationKey: string,
    replacement: number
  ) => {
    let translated = this.translateService.instant(translationKey);
    const replaceString = `%%0`;
    translated = translated.replace(replaceString, replacement.toString());
    return translated;
  };
}
